import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const OKRNotesSection = ({ goalData }:any) => {
    const { narrative } = goalData.goals;
    const { t } = useTranslation()
    
    return (
        <div className="okr_notes_section">
            <div className="okr_notes_header" role="heading" aria-level={2}>{t('Notes')}</div>
            <div className="okr_notes_body" dangerouslySetInnerHTML={{__html: narrative}}>
                {/* {narrative} */}
            </div>
        </div>
    )
}

export default OKRNotesSection;
